// extracted by mini-css-extract-plugin
module.exports = {"errorText":"DestroyArchive_errorText__3cdam","pendingMessage":"DestroyArchive_pendingMessage__TeIeY","container":"DestroyArchive_container__fZfUz"};